import { render, staticRenderFns } from "./planoSemanal.vue?vue&type=template&id=4a9f6a13"
import script from "./planoSemanal.vue?vue&type=script&lang=js"
export * from "./planoSemanal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports